<div fxLayout="column" fxLayoutGap="0.5rem" style="height: fit-content">
    <form [formGroup]="form">
        <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 txt-a-18-7">
            {{'Warning: you will not be able to modify the inserted date'|i18n}}
        </div>
        <div class="light-background dialog-padding">
            <div fxLayout="row" fxLayoutAlign="center center" class="ml-42 mr-42 mt-30">
                {{'Declare activation date of community validated by GSE.'|i18n}}
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="mt-40 mb-40">
                <div fxFlex="10"></div>
                <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{('Activation date'|i18n) + ':*'}}</div>
                <div fxFlex app-input-container class="ml-30">
                    <input class="input-font"
                           app-input
                           formControlName="activationDate"
                           [matDatepicker]="activationDate"
                           [min]="minActivationDate"
                           placeholder="{{'Activation date'|i18n}}">
                    <div *ngIf="!this.form.controls.activationDate.pristine && this.form.controls.activationDate.invalid"
                         app-error>
                        {{'Invalid date'|i18n}}
                    </div>
                </div>
                <mat-datepicker-toggle [for]="activationDate"></mat-datepicker-toggle>
                <mat-datepicker #activationDate disabled="false"></mat-datepicker>
                <div fxFlex="20"></div>
            </div>
        </div>
    </form>
</div>
